export default class EDEventListener {

    add(pName, pValue) {

        if(typeof pValue != "undefined") {
            this._events.set(pName, pValue)

            if(this._parent._DOMElement) {
                this._parent._DOMElement.addEventListener(pName, pValue)
            }
        }
    }

    has(pName) {
        return this._events.has(pName)
    }

    remove(pName) {

        const value = this._events.get(pName)

        if(value) {

            this._events.delete(pName)

            if(this._parent._DOMElement) {
                this._parent._DOMElement.removeEventListener(pName, value)
            }
        }
    }

    render() {

        this._events.forEach((value, name) => {
            this._parent._DOMElement.addEventListener(name, value)
        })
    }

    constructor(pParent, pListeners) {

        this._parent = pParent
        this._events = new Map()

        if(
            pListeners 
            && typeof pListeners === 'object' 
            && pListeners !== null
        ) {

            Object.entries(pListeners).forEach(([name, value]) => {
                this.add(name, value)
            })
        }

    }

}